module.exports = __webpack_public_path__ + "img/attention.37ed2e27.svg";